import cookie from "cookiejs";

import {
  AGREEMENT_COOKIE_EXPIRE,
  AGREEMENT_COOKIE_NAME,
  EAgreementEvents,
} from "./constants";

const evtAccepted = new CustomEvent(EAgreementEvents.ACCEPTED);

type TAgreementData = {
  isAccepted: boolean;
};

class Agreement {
  #agreementData: TAgreementData;

  constructor() {
    this.#agreementData = {
      isAccepted: false,
    };

    this.#syncFromCookie();
    this.init = this.init.bind(this);
  }

  get isAccepted() {
    return this.#agreementData.isAccepted;
  }

  #syncFromCookie() {
    this.#agreementData = {
      isAccepted: Boolean(cookie.get(AGREEMENT_COOKIE_NAME)),
    };
  }

  accept() {
    cookie.set(AGREEMENT_COOKIE_NAME, "true", { expires: AGREEMENT_COOKIE_EXPIRE });
    this.#agreementData = {
      isAccepted: true,
    };

    window.dispatchEvent(evtAccepted);
  }

  init() {
    this.#syncFromCookie();
  }
}

export { Agreement };
